export default "__VITE_ASSET__CXrunLGs__"